// src/pages/PostStoryPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, setDoc, doc } from '../firebase';
import './PostStoryPage.css';

const PostStoryPage = () => {
  const navigate = useNavigate();
  const accountNumber = localStorage.getItem('accountNumber');
  const name = localStorage.getItem('name');
  const [storyText, setStoryText] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!storyText.trim() || storyText.length > 50) {
      alert("Please enter a valid story (max 50 characters).");
      return;
    }
    const storyData = {
      posterID: accountNumber,
      posterName: name,
      text: storyText,
      timestamp: Date.now(),
      seenBy: [] // no friend has seen it yet
    };
    try {
      await setDoc(doc(db, 'stories', accountNumber), storyData);
      alert("Story posted successfully!");
      navigate('/home');
    } catch (error) {
      console.error("Error posting story:", error);
      alert("Failed to post story.");
    }
  };

  return (
    <div className="post-story-container">
      <h2>Post Your Story</h2>
      <form onSubmit={handleSubmit}>
        <textarea
          placeholder="What's your story? (max 30 characters)"
          value={storyText}
          onChange={(e) => setStoryText(e.target.value)}
          maxLength={30}
        />
        <button type="submit">Post Story</button>
      </form>
      <button className="cancel-button" onClick={() => navigate('/home')}>Cancel</button>
    </div>
  );
};

export default PostStoryPage;
